export default {
  attendStoreList: (state) => state.attendStoreList,
  attendStoreTotal: (state) => state.attendStoreTotal,
  attendStoreCount: (state) => state.attendStoreCount,
  attendStoreGroup: (state) => state.attendStoreGroup,
  sortText: (state) => state.sortText,
  sortType: (state) => state.sortType,
};
